import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import { useAuth } from "../../contexts/AuthContext";
import { APP_STORE_URL, INSTAGRAM_URL, PLAY_STORE_URL } from "../../constants/links";
import appstore from "../../assets/images/appstore.png";
import playstore from "../../assets/images/playstore.png";
import Logo from "./Logo";

const FooterLink = ({ to, href, children }) =>
  href ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-white/65 hover:text-white transition-colors"
    >
      {children}
    </a>
  ) : (
    <Link to={to} className="text-white/65 hover:text-white transition-colors">
      {children}
    </Link>
  );

const Column = ({ title, children }) => (
  <div>
    <h3 className="text-white font-bold mb-3">{title}</h3>
    <ul className="space-y-2 text-sm">{children}</ul>
  </div>
);

export const StoreBadges = ({ className = "" }) => (
  <div className={`flex flex-wrap gap-3 ${className}`}>
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2.5 h-12 rounded-xl bg-black/40 border border-white/15 px-4 hover:bg-black/60 transition-colors"
    >
      <img src={appstore} alt="" className="w-7 h-7 rounded-md" />
      <span className="text-right leading-tight">
        <span className="block text-[10px] text-white/60">حمّله من</span>
        <span className="block text-sm font-bold" dir="ltr">App Store</span>
      </span>
    </a>
    <a
      href={PLAY_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2.5 h-12 rounded-xl bg-black/40 border border-white/15 px-4 hover:bg-black/60 transition-colors"
    >
      <img src={playstore} alt="" className="w-7 h-7 rounded-md" />
      <span className="text-right leading-tight">
        <span className="block text-[10px] text-white/60">حمّله من</span>
        <span className="block text-sm font-bold" dir="ltr">Google Play</span>
      </span>
    </a>
  </div>
);

const SiteFooter = () => {
  const { isAuthenticated } = useAuth();
  return (
    <footer dir="rtl" className="relative border-t border-white/10 bg-header font-sans">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-12">
        <div className="grid grid-cols-2 gap-x-6 gap-y-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div className="col-span-2 md:col-span-1">
            <Logo className="w-16 h-16" />
            <p className="text-white/65 text-sm mt-4 leading-relaxed max-w-xs">
              لعبة أسئلة عربية للعائلة والأصدقاء. أنشئ لعبتك، اعرضها على الشاشة،
              وتنافسوا.
            </p>
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 text-sm font-semibold text-white/75 hover:text-white"
            >
              <FaInstagram className="text-lg" aria-hidden="true" />
              <span dir="ltr">@tarbaakw</span>
            </a>
          </div>

          <Column title="تربع">
            <li><FooterLink to={{ pathname: "/", hash: "#how" }}>كيف تلعب</FooterLink></li>
            <li><FooterLink to={{ pathname: "/", hash: "#modes" }}>الفئات</FooterLink></li>
            <li><FooterLink to="/pricing">الاشتراك</FooterLink></li>
            <li><FooterLink to="/links">صفحة الروابط</FooterLink></li>
          </Column>

          <Column title="الحساب">
            {isAuthenticated ? (
              <li><FooterLink to="/app/games">ألعابي</FooterLink></li>
            ) : (
              <>
                <li><FooterLink to="/login">تسجيل الدخول</FooterLink></li>
                <li><FooterLink to="/register">إنشاء حساب</FooterLink></li>
              </>
            )}
            <li><FooterLink to="/password-reset-request">نسيت كلمة المرور</FooterLink></li>
            <li><FooterLink to="/account-deletion-request">حذف الحساب</FooterLink></li>
          </Column>

          <Column title="معلومات">
            <li><FooterLink to="/mode-creation-terms">شروط إنشاء الفئات</FooterLink></li>
            <li><FooterLink href={INSTAGRAM_URL}>تواصل معنا</FooterLink></li>
          </Column>
        </div>

        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col-reverse gap-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} تربع. جميع الحقوق محفوظة.
          </p>
          <StoreBadges />
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
